import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  SetupIntentResponse,
  StripeCustomerResponse,
  StripePaymentMethodDto
} from '../../models/billing';
import { PagedResultDto } from '../../models/paged-result.model';
import {
  FacilityInvoice,
  InvoiceDto
} from '../../models/payments/invoices.dto';
import { HttpHelper } from '@umss/shared/utils';

@Injectable({ providedIn: 'root' })
export class CorporatePaymentApiService {
  private http = inject(HttpClient);

  createCustomer(corporateId: string): Observable<StripeCustomerResponse> {
    return this.http.post<StripeCustomerResponse>(
      `/api/Corporate/${corporateId}/stripe/customer`,
      {}
    );
  }

  createSetupIntent(corporateId: string): Observable<SetupIntentResponse> {
    return this.http.post<SetupIntentResponse>(
      `/api/Corporate/${corporateId}/stripe/setup-intent`,
      {}
    );
  }

  addPaymentMethod(
    corporateId: string,
    paymentMethodId: string
  ): Observable<void> {
    return this.http.post<void>(
      `/api/Corporate/${corporateId}/stripe/payment-methods`,
      { paymentMethodId }
    );
  }

  deletePaymentMethod(
    corporateId: string,
    paymentMethodId: string
  ): Observable<void> {
    return this.http.delete<void>(
      `/api/Corporate/${corporateId}/stripe/payment-methods/${paymentMethodId}`
    );
  }

  getPaymentMethods(corporateId: string): Observable<StripePaymentMethodDto[]> {
    return this.http.get<StripePaymentMethodDto[]>(
      `/api/Corporate/${corporateId}/stripe/payment-methods`
    );
  }

  updateDefaultPaymentMethod(
    corporateId: string,
    paymentMethodId: string
  ): Observable<void> {
    return this.http.put<void>(
      `/api/Corporate/${corporateId}/stripe/payment-methods/${paymentMethodId}`,
      { isDefault: true }
    );
  }

  getInvoices(
    corporateId: string,
    filters?: Partial<InvoiceDto>
  ): Observable<PagedResultDto<FacilityInvoice>> {
    const params = HttpHelper.toHttpParams(filters ?? {});
    return this.http.get<PagedResultDto<FacilityInvoice>>(
      `/api/Corporate/${corporateId}/invoices`,
      { params }
    );
  }
}
